import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton, Tooltip } from '@dixa/lib-shared-habla';
import { actions as personalActions } from 'components/settings/actions/personal';
import { useBreakpointValue } from 'utils/mediaQuery';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSelector } from 'utils/redux/useAppSelector';
export const ConversationHeaderSidebarOpenButton = () => {
    const dispatch = useAppDispatch();
    const isCustomCardMenuOpen = useAppSelector((state) => state.settings.personal.isCustomCardMenuOpen);
    const shouldButtonBeVisible = useBreakpointValue({ base: true, lg: false });
    const openCustomCardMenu = () => {
        dispatch(personalActions.personalCustomCardMenu({
            key: 'isCustomCardMenuOpen',
            value: true,
        }));
    };
    return shouldButtonBeVisible ? (_jsx(Tooltip, Object.assign({ dark: true, content: 'Show information' }, { children: _jsx(IconButton, { "data-testid": "show-information-button", icon: "bars", variant: "tertiary", active: isCustomCardMenuOpen, onClick: openCustomCardMenu }) }))) : null;
};
